var map = {
	"./ada.png": "a26a",
	"./avalanche.png": "b066",
	"./bat.png": "0af0",
	"./bnb.png": "b1c6",
	"./btc.png": "1dfd",
	"./cake.png": "4af1",
	"./doge.png": "a7c4",
	"./link.png": "4436",
	"./ltc.png": "8562",
	"./mana.png": "c2f5",
	"./ramp.png": "d079",
	"./solana.png": "06db",
	"./sxp.png": "e16b",
	"./usdc.png": "46cb",
	"./usdt.png": "456f",
	"./xvs.png": "1b5f",
	"./zil.png": "13be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3a4";